/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import styled from 'styled-components'

export const Label = styled.label`
  font-weight: bold;
  font-size: 14px;
  color: #757575;
`
export const Container = styled.div`
  display: flex;
  align-items: center;
  grid-gap: 5px;
`

export const customStyles = {
  option: () => ({
    fontFamily: 'Inter',
    fontSize: 12,
    color: 'var(--text-color-300)',
    padding: 10,
    ':hover': {
      backgroundColor: 'var(--yellow-500)',
      color: 'var(--text-color-500)',
    },
  }),
  control: () => ({
    fontFamily: 'Inter',
    fontSize: 12,
    minWidth: 140,
    width: '100%',
    border: '1px solid var(--text-color-100)',
    borderRadius: 4,
    display: 'flex',
  }),
  singleValue: () => ({
    color: 'var(--text-color-300)',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
}
